import { atom } from "jotai";

export const widgetAtom = atom<boolean>(false);
